var map = {
	"./5mb_pp_background_vertical.png": 1290,
	"./Gold_Star.png": 1707,
	"./Play_Icon_Blue.png": 6978,
	"./Play_Icon_Green.png": 7302,
	"./Play_Icon_Orange.png": 9221,
	"./Play_Icon_purple.png": 8277,
	"./THOTs.png": 2850,
	"./click.png": 6647,
	"./facebookfollowus.png": 4127,
	"./hri-2.png": 4337,
	"./hri-4.png": 9666,
	"./hri.png": 1373,
	"./hrn-2.png": 804,
	"./hrn-3.png": 3662,
	"./hrn-4.png": 1163,
	"./hrn.png": 2479,
	"./hrnetgroup.png": 5765,
	"./instagramfollowus.png": 966,
	"./line_icon.png": 2997,
	"./linkedincontact.png": 6936,
	"./linkedinfollowus.png": 7605,
	"./mailcontact.png": 9640,
	"./oct_background.jpg": 5584,
	"./octomate.png": 3324,
	"./phoneiconcontact.png": 3134,
	"./pp_background.jpg": 1123,
	"./ppl first 65px.png": 1553,
	"./ppmy.png": 3879,
	"./pps.png": 9957,
	"./rf-2.png": 3502,
	"./rf-3.png": 2429,
	"./rf.png": 2134,
	"./webfollowus.png": 2167,
	"./whatsappcontact.png": 2327
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6068;